import { NavBarItem, getNavBarItems } from './helpers';

const NAVBAR_ITEMS: NavBarItem[] = getNavBarItems([
    {
        title: 'Client',
        items: [
            {
                title: 'Roster',
                url: '/client/roster/',
                groups: ['apex_client'],
            },
            {
                title: 'Campaigns',
                url: '/client/campaigns/',
                groups: ['apex_client'],
            },
        ],
    },
    {
        title: 'Campaign Manager',
        items: [
            {
                title: 'Bookings',
                url: '/campaign-manager/bookings/',
                groups: ['apex_manager'],
            },
            {
                title: 'Creators',
                url: '/campaign-manager/creators/',
                groups: ['apex_manager'],
            },
        ],
    },
    {
        title: 'Finance',
        items: [
            {
                title: 'Creator Payments',
                url: '/finance/creator-payments/',
                groups: ['apex_finance'],
            },
        ],
    },
    {
        title: 'Admin',
        items: [
            {
                title: 'Bookings',
                url: '/admin/bookings/',
                groups: ['apex_admin'],
            },
            {
                title: 'Creators',
                url: '/admin/creators/',
                groups: ['apex_admin'],
            },
        ],
    },
    {
        title: 'Data',
        items: [
            {
                title: 'Download',
                url: '/data/download/',
                groups: ['apex_admin'],
            },
        ],
    },
]);

export { NAVBAR_ITEMS };
